
export enum HotspotThemesEnum {
  classicAnnotation = 'classic-annotation',
  classicHotspot = 'classic-hotspot',
  studioNext = 'studio-light'
}
